const mutations = {
  // 搜索列表参数
  udpateSettlementSearchByMutation(state, data) {
    state.settlementSearch = data
    localStorage.setItem('settlementSearch', JSON.stringify(data))
  },
  // 搜索教育局列表参数
  updateSettlementDetailsSearch(state, data) {
    state.settlementDetailsSearch = data
    localStorage.setItem('settlementDetailsSearch', JSON.stringify(data))
  },
  // 切换实际、通用分账单
  updateTrueTally(state, data) {
    state.isTrueTally = data
  },

  // 审批节点
  udpateNodeEnum(state, data) {
    state.nodeEnum = data
  },
  // 结算账单审批流程
  udpateAudit(state, data) {
    state.audit = data
  },

  // 审核节点参数
  updateProcessConfiguration(state, data) {
    state.settlementConfig = data
  }
}

export default mutations
